const GameActionType = {
  CHANGE_GAME_LOADING_STATE: 'CHANGE_GAME_LOADING_STATE',

  // please delete after campaign v2 be ready
  GET_FREE_GAME_PROVIDERS: 'GET_FREE_GAME_PROVIDERS',
  SAVE_FREE_GAME_PROVIDERS: 'SAVE_FREE_GAME_PROVIDERS',
  RESET_FREE_GAME_PROVIDERS: 'RESET_FREE_GAME_PROVIDERS',

  GET_FREE_GAMES_V2_PROVIDERS: 'GET_FREE_GAMES_V2_PROVIDERS',
  SAVE_FREE_GAMES_V2_PROVIDERS: 'SAVE_FREE_GAMES_V2_PROVIDERS',
  RESET_FREE_GAMES_V2_PROVIDERS: 'RESET_FREE_GAMES_V2_PROVIDERS',

  GET_FREE_GAMES: 'GET_FREE_GAMES',
  SAVE_FREE_GAMES: 'SAVE_FREE_GAMES',
  RESET_FREE_GAMES: 'RESET_FREE_GAMES',

  GET_FREE_GAMES_V2: 'GET_FREE_GAMES_V2',
  SAVE_FREE_GAMES_V2: 'SAVE_FREE_GAMES_V2',
  RESET_FREE_GAMES_V2: 'RESET_FREE_GAMES_V2',

  GET_FREE_GAME_AMOUNT_RESTRICTIONS: 'GET_FREE_GAME_AMOUNT_RESTRICTIONS',
  SAVE_FREE_GAME_AMOUNT_RESTRICTIONS: 'SAVE_FREE_GAME_AMOUNT_RESTRICTIONS',
  RESET_FREE_GAME_AMOUNT_RESTRICTIONS: 'RESET_FREE_GAME_AMOUNT_RESTRICTIONS',

  CHANGE_FREE_GAME_LOADING_STATE: 'CHANGE_FREE_GAME_LOADING_STATE',
  CHANGE_FREE_GAME_AMOUNT_LOADING_STATE: 'CHANGE_FREE_GAME_AMOUNT_LOADING_STATE',

  GET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS: 'GET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS',
  SAVE_FREE_GAMES_V2_AMOUNT_RESTRICTIONS: 'SAVE_FREE_GAMES_V2_AMOUNT_RESTRICTIONS',
  RESET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS: 'RESET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS',
};

export default GameActionType;
